export default __webpack_public_path__ + "cf2e89e31e4294d9b8fc7166bed6c93f.png";